export const SincerityScoreMap=new Map([
    ["Very Satisfied",5],
    ["Moderately Satisfied",3],
    ["Slightly Satisfied",2],
    ["Satisfied",1],
    ["Neutral",0],
    ["Dissatisfied",-1],
    ["Slightly Dissatisfied",-2],
    ["Moderately Dissatisfied",-3],
    ["Very Dissatisfied",-5]
])
export const SincerityScoreMapString=new Map([
    [5,"Very Satisfied"],
    [3,"Moderately Satisfied"],
    [2,"Slightly Satisfied"],
    [1,"Satisfied"],
    [0,"Neutral"],
    [-1,"Dissatisfied"],
    [-2,"Slightly Dissatisfied"],
    [-3,"Moderately Dissatisfied"],
    [-5,"Very Dissatisfied"]
])